import { printDateTime } from "../../scripts/helpers/date.time.now";
import headersWithToken from "../../scripts/helpers/headers.token";
import prettyFloat from "../../scripts/helpers/pretty.float";
import twoDigitFormat from "../../scripts/helpers/two.digit.format";
import uniqRandomNumber from "../../scripts/helpers/uniq.random.number";
import API from "../../settings/api";
import { CURRENCY, CoT_MODE, DEAL_MOVEMENT_TYPES, DEAL_PRICE_WATCH_MODE, DEAL_TYPES } from "../../settings/constants";
import { post } from "axios";

async function changeCurrency( store, currency ) {

  store.setState({ currency });

  const headers = headersWithToken();
  post( API.settings.changeCurrency, { currency }, { headers } );

}

async function togglePriceViewMode( store ) {

  const current = store.state.deal_price_watch_mode;

  store.setState({

    deal_price_watch_mode: current === DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL

      ? DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER
      : DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL

  });

  const headers = headersWithToken();
  post( API.settings.changePriceWatchMode, { price_watch_mode: current }, { headers } );

}

async function toggleCommissionOrTimeMode( store ) {

  const current = store.state.comission_or_time;

  store.setState({

    comission_or_time: current === CoT_MODE.COMISSION

      ? CoT_MODE.TIME
      : CoT_MODE.COMISSION

  });

  const headers = headersWithToken();
  post( API.settings.changeCommissionOrTimeMode, { time_or_commission_mode: current }, { headers } );

}

async function load( store, { reload = false } ) {

  try {
    
    const headers = headersWithToken();
    const { status, data } = await post( API.deals.all, {}, { headers } );

    if ( data?.error ) { throw( data.error ); }
    if ( status !== 200 ) { throw("Нет соединения с сервером"); }

    const { orders = [], history = [] } = data;

    store.setState({

      orders,
      history

    });

    reload && reload();

  } catch ( err ) {

    console.error(`deals.load err:`, err );

  }

}

async function create( store, ticker, reload = false ) {

  const d = new Date();
  const date = `${ twoDigitFormat( d.getDate() ) }.${ twoDigitFormat( d.getMonth() + 1 ) }.${ d.getFullYear() } ${ twoDigitFormat( d.getHours() ) }:${ twoDigitFormat( d.getMinutes() ) }`

  const id = uniqRandomNumber();

  const newOrder = {

    id: id,
    name: ticker,
    type: false,
    amount: 0,
    result: 0,
    comment: "",
    currency: store.state.currency,
    date_create: date,
    date_update: date,
    movements: []

  }

  const temp = store.state.orders;
  temp.push( newOrder );
  store.setState({ orders: temp });
 
  const headers = headersWithToken();
  post( API.deals.add, { id, name: ticker }, { headers } );

  reload && reload();

}

async function setAttribute( store, id, attr, value ) {

  let orders = store.state.orders;
  let order = orders.find( el => +el.id === +id );
  if ( !order ) return;
  order[ attr ] = value;

  store.setState({ orders });

}

async function comment( store, id, comment, reloadHistory = false ) {

  const headers = headersWithToken();

  store.actions.deals.setAttribute( id, "comment", comment );

  await post( API.deals.comment, { id, comment }, { headers } );

  if ( reloadHistory ) {

    const { history } = store.state;
    let updatedHistory = history; 
    
    for ( let i = 0; i < updatedHistory.length; i++ ) {

      let orders = updatedHistory[ i ].orders;
      let order = orders.find( order => order.id === id );

      if ( order ) { order.comment = comment; }

      updatedHistory[ i ].orders = orders;
    
    }

    store.actions.deals.load({ reload: false });

  }

}

async function setMaxAmount( store, id, amount ) {

  let orders = store.state.orders;
  let order = orders.find( el => +el.id === +id );
  order.amount = amount;

  store.setState({ orders });

  const headers = headersWithToken();
  post( API.deals.setMaxAmount, { id, amount }, { headers } );

}

async function save( store, transaction, reload = false ) {

  console.log(`deals.save() transaction = `, transaction );

  
  let date;


  if ( typeof transaction.date_update === "object" ) {

    if ( transaction.date_update === null ) { 
      
      transaction.date_update = new Date( transaction.movements[ transaction.movements.length - 1 ].date );
    
    }
    
    const d = transaction.date_update;
    date = `${ twoDigitFormat( d.getDate() ) }.${ twoDigitFormat( d.getMonth() + 1 ) }.${ twoDigitFormat( d.getFullYear() ) }`;
  
  } else {

    let char = " ";

    if ( transaction.date_update.indexOf( 'T' ) !== -1 ) { char = "T"; }

    date = transaction.date_update.split( char )[ 0 ];

  }

  const form = {

    id: transaction.id,
    type: transaction.type,
    date_update: transaction.date_update,
    name: transaction.name,
    movements: transaction.movements,
    amount: transaction.amount,
    result: transaction.result,
    currency: store.state.currency,
    comment: transaction.comment

  };

  let _history = store.state.history;

  if ( store.state.history.length > 0 ) {

    let dateFinded = store.state.history.find( day => day.date === date );

    if ( dateFinded ) {

      for ( let i = 0; i < _history.length; i++ ) {

        if ( _history[ i ].date === date ) {

          _history[ i ].result = parseFloat( _history[ i ].result ) + parseFloat( form.result );
          _history[ i ].orders = [

            ..._history[ i ].orders,
            form

          ]

        }

      }

    } else {

      _history = [

        { 
        
          date: date,
          result: form.result,
          orders: [ form ]
        
        }

      ]

      for ( let i = 0; i < store.state.history.length; i++ ) {

        _history.push( store.state.history[ i ] );

      }

    }

  } else {

    _history = [
      
      { 
          
        date: date,
        result: form.result,
        orders: [ form ]
      
      }
    
    ];

  }

  store.setState({ history: _history });
   
  const headers = headersWithToken();
  post( API.deals.close, { id: transaction.id }, { headers } );

  reload && reload();

}

async function close( store, saveToHistory, closeCard, transaction, reload = false ) {

  let updated = [];
  const headers = headersWithToken();

  for ( let i = 0; i < store.state.orders.length; i++ ) {

    if ( parseFloat( store.state.orders[ i ].id ) === parseFloat( transaction ) ) {
      
      let thisDeal = store.state.orders[ i ];

      if ( saveToHistory ) {

        store.actions.deals.save( thisDeal, reload );

      }

      if ( !closeCard ) {
        
        store.actions.deals.create( thisDeal.name );        
      
      } else {

        if ( !saveToHistory ) { 
          
          post( API.deals.remove, { id: thisDeal.id }, { headers } ); 
        
        }

      }

    } else {

      updated.push( store.state.orders[ i ] );

    }

  }

  store.setState({ orders: updated });
  reload && reload();

}

async function remove( store, id ) {

  if ( !window.confirm(`Вы точно хотите удалить сделку? Это действие отменить нельзя!`) ) { return; };
  
  const { history } = store.state;
  let updatedHistory = history; 
  
  for ( let i = 0; i < updatedHistory.length; i++ ) {

    updatedHistory[ i ].orders = updatedHistory[ i ].orders.filter( order => order.id !== id )
  
  }

  store.actions.popup.hide();
  
  const headers = headersWithToken();
  await post( API.deals.remove, { id }, { headers } );

  store.actions.deals.load({ reload: false });

}

async function view( store, info ) {

  store.setState({
    popup_deal_info: info
  })

  store.actions.popup.show("deal_info");

}

const movement = {

  add: async ( store, { transaction, type, amount, price, commission, actualAmountOfDeal = false }, reload = false, updateState = true ) => {

    let params = { id: transaction }
    let updated = JSON.parse( JSON.stringify( store.state.orders ) );
    let result = 0;

    const id = uniqRandomNumber();

    for ( let i = 0; i < updated.length; i++ ) {

      if ( parseFloat( updated[ i ].id ) === parseFloat( transaction ) ) {

        let movements = updated[ i ].movements;

        if ( movements.length === 0 ) { 
          
          updated[ i ].type = type; 
          params.type = type; 
        
        }
    
        movements = [
    
          ...movements,
          { 
            id: id,
            type, 
            amount: actualAmountOfDeal || amount, 
            price: actualAmountOfDeal 
              ? ( price / amount ) * actualAmountOfDeal
              : price, 
            commission, 
            date: new Date() //TODO from backend
          }
    
        ];

        result = calculateOrderResult( updated[ i ].type, movements );

        if ( actualAmountOfDeal ) { 
          
          // если передано кол-во акций в сделке, значит это предпросмотр сделки
          // тогда мы считаем результат сделки от того кол-ва акций которое 
          // было введено в поле. Как будто продали все акции по этой цене, 
          // но выдаём сумму которая будет получена в рез-те продажи указанного кол-ва

          result = prettyFloat( ( result / actualAmountOfDeal ) * amount );

        }

        const d = new Date();
        const date = `${ twoDigitFormat( d.getDate() ) }.${ twoDigitFormat( d.getMonth() + 1 ) }.${ d.getFullYear() } ${ twoDigitFormat( d.getHours() ) }:${ twoDigitFormat( d.getMinutes() ) }`
            
        updated[ i ].date_update = date;
        updated[ i ].movements = movements;
        updated[ i ].result = result;

        params.movements = JSON.stringify( movements );
        params.result = result; 
      
      }

    }
   
    if ( updateState ) {
    
      store.setState({ orders: updated });
      
      const headers = headersWithToken();    
      post( API.deals.movements, params, { headers } );
      
    }

    reload && reload();

    return result;

  },

  remove: async ( store, { transaction, movement_id }, reload = false ) => {

    if ( !window.confirm("Удалить эту операцию?") ) { return; }

    let params = { id: transaction }
    let updated = store.state.orders;

    for ( let i = 0; i < updated.length; i++ ) {

      if ( parseFloat( updated[ i ].id ) === parseFloat( transaction ) ) {

        let movements = updated[ i ].movements;
        let updatedMovements = [];
       
        movements.forEach( m => {

          parseFloat( m.id ) !== parseFloat( movement_id ) && updatedMovements.push( m );

        });

        const updatedResult = calculateOrderResult( updated[ i ].type, updatedMovements );

        let updatedMaxAmount = 0;

        for ( let j = 0; j < updatedMovements; j++ ) {

          if ( updatedMaxAmount < updatedMovements[ j ].amount ) {

            updatedMaxAmount = updatedMovements[ j ].amount;

          }

        }

        updated[ i ].result    = updatedResult;
        updated[ i ].amount    = updatedMaxAmount;
        updated[ i ].movements = updatedMovements;

        params.movements = JSON.stringify( updatedMovements );
        params.result = updatedResult; 

      }

    }

    store.setState({ orders: updated });
    
    const headers = headersWithToken();    
    post( API.deals.movements, params, { headers } );

    reload && reload();

  },

  removeAll: async ( store, transaction, reload = false ) => {

    if ( !window.confirm("Сбросить движения внутри сделки без сохранения результата в истории сделок?") ) { return; }
    
    let updated = store.state.orders;

    for ( let i = 0; i < updated.length; i++ ) {

      if ( parseFloat( updated[ i ].id ) === parseFloat( transaction ) ) {

        updated[ i ].movements = [];
        updated[ i ].result = 0;

      }

    }

    store.setState({ orders: updated });
    
    const params = {

      id: transaction,
      movements: "[]",
      result: 0

    }

    const headers = headersWithToken();    
    post( API.deals.movements, params, { headers } );

    reload && reload();

  }

}

function calculateOrderResult( order_type, order_movements ) {

  console.log(`${ printDateTime() } called calculateOrderResult`);

  let result = 0;

  order_movements.forEach( movement => {

    if ( order_type === DEAL_TYPES.LONG ) { //long

      if ( movement.type === DEAL_MOVEMENT_TYPES.BUY ) {
  
        result = parseFloat( result ) - ( parseFloat( movement.price ) + parseFloat( movement.commission ) );
  
      } else if ( movement.type === DEAL_MOVEMENT_TYPES.SELL ) {
  
        result = parseFloat( result ) + ( parseFloat( movement.price ) - parseFloat( movement.commission ) );
  
      }

    } else if ( order_type === DEAL_TYPES.SHORT ) { //short

      if ( movement.type === DEAL_MOVEMENT_TYPES.BUY ) {
  
        let _result = parseFloat( result ) - ( parseFloat( movement.price ) + parseFloat( movement.commission ) );
        // if ( _result < 0 ) { _result = Math.abs(_result); } else { _result = _result; }
        result = _result;
  
      } else if ( movement.type === DEAL_MOVEMENT_TYPES.SELL ) {
  
        result = parseFloat( result ) + ( parseFloat( movement.price ) - parseFloat( movement.commission ) );
  
      }

    }

  });

  if ( result.toString().indexOf('.') !== -1 ) {

    result = parseFloat( result ).toFixed( 2 );

  }

  return result;

}

function countMovementTypesAndPrices( movements ) {

  let buyCounter = 0;
  let sellCounter = 0;
  let buySummaryPrice = 0;
  let sellSummaryPrice = 0;
  let buySummaryCommission = 0;
  let sellSummaryCommission = 0;

  movements.forEach( movement => {

    if ( +movement.type === DEAL_MOVEMENT_TYPES.BUY ) {
      
      buyCounter += 1;
      buySummaryPrice += +movement.price
      buySummaryCommission += +movement.commission
    
    } else if ( +movement.type === DEAL_MOVEMENT_TYPES.SELL ) {

      sellCounter += 1;
      sellSummaryPrice += +movement.price
      sellSummaryCommission += +movement.commission
    
    }

  });

  return { 

    buyCounter, 
    buySummaryPrice,
    buySummaryCommission,
    sellCounter,
    sellSummaryPrice,
    sellSummaryCommission,

  }

}

function calculateActualAmountPriceComissionOfDeal({ order_type, order_movements }) {

  
  let price = parseFloat( order_movements[ 0 ].price );
  let amount = parseFloat( order_movements[ 0 ].amount );
  let commission = parseFloat( order_movements[ 0 ].commission );

  for ( let i = 1; i < order_movements.length; i++ ) { //// i=1, всё верно

    commission += parseFloat( order_movements[ i ].commission );

    if ( order_type === DEAL_TYPES.LONG ) {

      if ( order_movements[ i ].type === DEAL_MOVEMENT_TYPES.BUY ) {

        price += parseFloat( order_movements[ i ].price );
        amount += parseFloat( order_movements[ i ].amount );        

      } else if ( order_movements[ i ].type === DEAL_MOVEMENT_TYPES.SELL ) {

        price -= parseFloat( order_movements[ i ].price );
        amount -= parseFloat( order_movements[ i ].amount );

      }

    } else if ( order_type === DEAL_TYPES.SHORT ) {

      if ( order_movements[ i ].type === DEAL_MOVEMENT_TYPES.BUY ) {

        price -= parseFloat( order_movements[ i ].price );
        amount -= parseFloat( order_movements[ i ].amount );        

      } else if ( order_movements[ i ].type === DEAL_MOVEMENT_TYPES.SELL ) {

        price += parseFloat( order_movements[ i ].price );
        amount += parseFloat( order_movements[ i ].amount );

      }

    }

  }

  return {

    price,
    amount,
    commission,

  }

}

function calculateMovementPriceForConcreticResult({ tariff_commission, order_type, order_movements, wanted_result = 0 }) {

  let onePaperPrice = 0; // цена 1 акции
  let wantedResultSummaryPrice = 0; // сумма сделки с учётомв всех комиссий, чтобы прийти к желаемому результату сделки

  if ( order_movements.length < 1 ) { return 0; }

  let price = parseFloat( order_movements[ 0 ].price );
  let amount = parseFloat( order_movements[ 0 ].amount );
  let commission = parseFloat( order_movements[ 0 ].commission );

  if ( order_movements.length > 1 ) {

    const actualNumbers = calculateActualAmountPriceComissionOfDeal({ order_type, order_movements });

    price = actualNumbers.price;
    amount = actualNumbers.amount;
    commission = actualNumbers.commission;

  }

  onePaperPrice = parseFloat( price ) / parseFloat( amount );

  let step = 0.01;
  let resultPaperPrice = +onePaperPrice.toFixed( 2 );
  
  let stepsCounter = 0; //сколько было итераций цикла, чисто для статистики
  
  if ( order_type === DEAL_TYPES.LONG ) {
    
    wantedResultSummaryPrice = parseFloat( commission * 2 ) + parseFloat( price ) + parseFloat( wanted_result );
    const comissionFromWantedResultSummaryPrice = wantedResultSummaryPrice / 100 * tariff_commission;
    wantedResultSummaryPrice = parseFloat( wantedResultSummaryPrice + parseFloat( comissionFromWantedResultSummaryPrice.toFixed( 2 ) ) );

    while ( 
      
      ( 
        
        resultPaperPrice + parseFloat( resultPaperPrice / 100 * tariff_commission ) 

      ) * parseFloat( amount ) < wantedResultSummaryPrice 
                
    ) {

      resultPaperPrice += step;
      stepsCounter += 1;

    }

    console.log(``);
    console.log(`calculateMovementPriceForConcreticResult: совершила ${ stepsCounter } итераций и вычислила сумму одной акции = ${ parseFloat(resultPaperPrice) }`);
    console.log(`calculateMovementPriceForConcreticResult: для этого мы пытаемся совершить сделку по цене (сумма всех акций + комиссия) = ${ typeof parseFloat(wantedResultSummaryPrice)}`, parseFloat(wantedResultSummaryPrice) );
    const forDebug = ( parseFloat(resultPaperPrice) + ( parseFloat(resultPaperPrice) / 100 * tariff_commission ) ) * parseFloat(amount);
    console.log(`calculateMovementPriceForConcreticResult: resultPrice = ( ${resultPaperPrice} + ( ${resultPaperPrice} / 100 * ${tariff_commission} = ${ parseFloat(resultPaperPrice) / 100 * tariff_commission } ) ) * ${parseFloat(amount)} а именно ${ typeof parseFloat(forDebug)}`, parseFloat(forDebug) );
    console.log(``);

  } else if ( order_type === DEAL_TYPES.SHORT ) {

    // wantedResultSummaryPrice = parseFloat( commission * 2 ) + parseFloat( price ) + parseFloat( wanted_result );
    wantedResultSummaryPrice = parseFloat( price ) - parseFloat( commission ) - parseFloat( wanted_result );
    const comissionFromWantedResultSummaryPrice = wantedResultSummaryPrice / 100 * tariff_commission;
    wantedResultSummaryPrice = parseFloat( wantedResultSummaryPrice - parseFloat( comissionFromWantedResultSummaryPrice.toFixed( 2 ) ) );

    while ( 
      
      ( 
        
        resultPaperPrice + parseFloat( resultPaperPrice / 100 * tariff_commission ) 

      ) * parseFloat( amount ) > wantedResultSummaryPrice 
                
    ) {

      resultPaperPrice -= step;
      stepsCounter += 1;

    }

    console.log(``);
    console.log(`calculateMovementPriceForConcreticResult: совершила ${ stepsCounter } итераций и вычислила сумму одной акции = ${ parseFloat(resultPaperPrice) }`);
    console.log(`calculateMovementPriceForConcreticResult: для этого мы пытаемся совершить сделку по цене (сумма всех акций + комиссия) = ${ typeof parseFloat(wantedResultSummaryPrice)}`, parseFloat(wantedResultSummaryPrice) );
    const forDebug = ( parseFloat(resultPaperPrice) + ( parseFloat(resultPaperPrice) / 100 * tariff_commission ) ) * parseFloat(amount);
    console.log(`calculateMovementPriceForConcreticResult: resultPrice = ( ${resultPaperPrice} + ( ${resultPaperPrice} / 100 * ${tariff_commission} = ${ parseFloat(resultPaperPrice) / 100 * tariff_commission } ) ) * ${parseFloat(amount)} а именно ${ typeof parseFloat(forDebug)}`, parseFloat(forDebug) );
    console.log(``);

  }

  return {
    
    price: resultPaperPrice.toFixed( 2 ),
    amount
  
  };

}

export {

  togglePriceViewMode,
  toggleCommissionOrTimeMode,
  changeCurrency,
  load,
  create,
  comment,
  movement,
  save,
  view,
  close,
  remove,
  setAttribute,
  setMaxAmount,

  countMovementTypesAndPrices,
  calculateOrderResult,
  calculateMovementPriceForConcreticResult,
  calculateActualAmountPriceComissionOfDeal

}